module.exports = __webpack_public_path__ + "static/media/logo_no.a5b0d4ca.svg";